import React from 'react'
import styled from 'styled-components'
import { Loader } from './Loader'

const LoaderContainerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  &.fade-out {
    opacity: 0;
    pointer-events: none;
  }
`

export const LoaderContainer = ({ isLoading }) => (
  <LoaderContainerWrapper className={!isLoading ? 'fade-out' : ''}>
    <Loader />
  </LoaderContainerWrapper>
)
